module.exports = __webpack_public_path__ + "static/media/22.e30219b2.JPG";